/**
 * The provenance line under every AI-drafted artefact: which prompt version
 * produced it and the `ai_inference` record holding the exact prompt and
 * response. Shown because an artefact without this is not reproducible.
 */

import { Code, Group, Text } from "@mantine/core";
import { IconSparkles } from "@tabler/icons-react";

interface Props {
  promptVersion: string | null;
  inferenceId: string | null;
  extra?: string;
}

export function Provenance({ promptVersion, inferenceId, extra }: Props) {
  if (!promptVersion && !inferenceId) return null;
  return (
    <Group gap={6} wrap="wrap">
      <IconSparkles size={13} style={{ opacity: 0.6 }} />
      <Text size="xs" c="dimmed">
        AI-drafted · prompt <Code>{promptVersion ?? "—"}</Code> · inference{" "}
        <Code>{inferenceId ?? "—"}</Code>
        {extra ? ` · ${extra}` : ""}
      </Text>
    </Group>
  );
}

export function AdvisoryNote() {
  return (
    <Text size="xs" c="dimmed" fs="italic">
      AI-generated decision support. A human reviews and confirms before the next stage uses it.
    </Text>
  );
}
